import React, { useEffect } from 'react';
import PageHeader from '../innovher/PageHeader';
import { IMG } from '../../lib/images';
import SEO from '../SEO';

export default function SixMonthCelebrationPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
    const els = document.querySelectorAll('.reveal-up');
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-revealed'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  const gallery = [
    IMG.eventCeleb1, // 0: 2x2
    IMG.eventCeleb2, // 1: 2x2
    IMG.eventCeleb3, // 2: 1x1
    IMG.eventCeleb4, // 3: 1x1
    IMG.eventCeleb5, // 4: 1x1
    IMG.eventCeleb6, // 5: 1x1
    IMG.eventCeleb7, // 6: 2x1
    IMG.eventCeleb8  // 7: 2x1
  ];

  return (
    <>
      <SEO 
        title="6-Month Celebration | InnovHer Event"
        description="InnovHer's 6-month celebration in Jaipur with founders, investors and mentors, marking milestones across the venture-building journey."
        keywords="InnovHer milestone, Jaipur startup events, InnovHer celebration, venture builder Rajasthan"
      />
      <PageHeader
        eyebrow="Signature Event"
        title={<>Innovher <span className="text-[#ff8ec5]">6 Month Celebration</span></>}
        subtitle="On July 9th, 2024, Innovher celebrated its 6-month journey at Club Neo, Horizon Tower, Jaipur. The event was a testament to Innovher's commitment to fostering entrepreneurship."
        image={IMG.eventCeleb1}
        breadcrumbs={[{ label: 'Events', to: '#' }, { label: '6 Month Celebration' }]}
      />

      <section className="relative bg-[#08080a] py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          
          <div className="reveal-up max-w-4xl mx-auto text-center mb-24">
            <h2 className="text-3xl md:text-5xl font-semibold tracking-tight text-white mb-8">Innovher Milestone Celebration - 6 Months Journey</h2>
            <p className="text-lg text-white/60 leading-relaxed text-justify md:text-center">
              The event, attended by key stakeholders including founders, investors, mentors, and startups, was a testament to Innovher's commitment to fostering entrepreneurship. Dr. Shweta Choudhary welcomed attendees, followed by a review of achievements presented by Mr. Shivam Lohiya, highlighting milestones such as ₹2 crores in funding approvals and significant revenue growth for startups. The celebration included interactive activities, a cake-cutting ceremony, and discussions on future plans, solidifying Innovher's mission to support and empower the startup ecosystem.
            </p>
          </div>

          <div className="reveal-up">
            <h3 className="text-2xl font-bold text-white mb-8 border-l-4 border-[#ff8ec5] pl-4">Event Gallery</h3>
            
            <div className="grid grid-cols-1 md:grid-cols-4 auto-rows-[250px] md:auto-rows-[300px] gap-4 md:gap-6">
              {gallery.map((src, i) => {
                const getBentoClasses = (index) => {
                  switch(index) {
                    case 0: return "md:col-span-2 md:row-span-2";
                    case 1: return "md:col-span-2 md:row-span-2";
                    case 6: return "md:col-span-2 md:row-span-1";
                    case 7: return "md:col-span-2 md:row-span-1";
                    default: return "md:col-span-1 md:row-span-1";
                  }
                };
                
                return (
                <div key={i} className={`relative group rounded-3xl overflow-hidden bg-white/5 border border-white/10 ${getBentoClasses(i)}`}>
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-transparent transition-colors duration-500 z-10 pointer-events-none" />
                  <img 
                    src={src} 
                    alt={`6 Month Celebration Gallery ${i + 1}`} 
                    className="absolute inset-0 w-full h-full object-contain transform group-hover:scale-105 transition-transform duration-700" 
                    loading="lazy"
                  />
                </div>
              )})}
            </div>
          </div>

        </div>
      </section>
    </>
  );
}
